import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { clear_auth, set_auth } from "../../reducers/Auth";
import { Helmet } from "react-helmet";
import RefreshIcon from "../../assets/icons/refresh.svg";
import moment from "moment/moment";
import { Bar } from "react-chartjs-2";
import Chart from "react-google-charts";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import { TourContext } from "../guideComponent/guideTourProvicer";
import "./pemantauan.css";

export class Pemantauan extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        let currentDate = new Date();
        let currentYear = currentDate. getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.state = {
            selectedBulan: currentMonth.toString().padStart(2, '0') // Format dua digit
        };
        this.state = {
            data: [],
            selectedBulanTahun: moment().format('MM'),
            selectedBulan: moment().format('MM'),
            perusahaan: [],
            selectedYear: currentYear,
            selectedTahun: currentYear,
            absensiTerlambat: [],
            absensiTepatWaktu: [],
            absensi: [],
            karyawan: [],
            loading: true,
            loadingAbsensi: true,
            loadingTerlambat: true,
            loadingTepatWaktu: true,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBulanTahunChange = this.handleBulanTahunChange.bind(this);
        this.handleBulan = this.handleBulan.bind(this);
        this.handleTahun = this.handleTahun.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.resetFilterTerlambat = this.resetFilterTerlambat.bind(this);
        this.resetFilterTepatWaktu = this.resetFilterTepatWaktu.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }
    getMonthName(monthValue) {
        const months = [
            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ];

        if (monthValue >= 1 && monthValue <= 12) {
            return months[monthValue - 1];
        } else {
            return "Bulan tidak valid";
        }
    }

    generateOptions() {
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const monthsToShow = 12;
        const options = [];

        for (let i = 0; i < monthsToShow; i++) {
            const monthValue = currentMonth - i > 0 ? currentMonth - i : currentMonth - i + 12;
            options.push(
                <option key={monthValue} value={monthValue.toString().padStart(2, '0')}>
                    {this.getMonthName(monthValue)}
                </option>
            );
        }
        return options;
    }

    resetFilter(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loadingAbsensi: true,
            }, () => this.loadDataAbsensi()
        )
    }
    resetFilterTerlambat(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loadingTerlambat: true,
            }, () => this.loadData()
        )
    }

    resetFilterTepatWaktu(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loadingTepatWaktu: true,
            }, () => this.loadDataTepatWaktu()
        )
    }

    handleBulan = (event) => {
        this.setState({ selectedBulanTahun: event.target.value, loadingTerlambat: true }, () => {
            this.loadData();
        });
    };

    handleBulanTahunChange = (event) => {
        this.setState({ selectedBulan: event.target.value, loadingAbsensi: true  }, () => {
            this.loadDataAbsensi();
        });
    };

    handleTahun = (event) => {
        this.setState({ selectedYear: event.target.value, loadingTerlambat: true  }, () => {
            this.loadData();
        });
    };

    handleYearChange = (event) => {
        this.setState({ selectedTahun: event.target.value, loadingAbsensi: true  }, () => {
            this.loadDataAbsensi();
        });
    };

    handleBulanTepatWaktu = (event) => {
        this.setState({ selectedBulanTahun: event.target.value, loadingTepatWaktu: true }, () => {
            this.loadDataTepatWaktu();
        });
    };

    handleTahunTepatWaktu = (event) => {
        this.setState({ selectedYear: event.target.value, loadingTepatWaktu: true  }, () => {
            this.loadDataTepatWaktu();
        });
    };

    loadData() {
        this.setState({
            loadingTerlambat: true
        });
        let form = {
            tahun: this.state.selectedYear,
            bulan: this.state.selectedBulanTahun
        };
        this.props.request('presensi/pemantauan-terlambat-v2', form, 'POST')
            .then(response => {
                if (response && response.success) {
                    var tanggal = [];
                    var terlambat = [];
                    var nama = [];
                    response.data.map((item, index) => {
                        tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                        terlambat.push((item.terlambat !== null ? item.terlambat : 0));
                        nama.push((item.nama !== null ? item.nama : 0));
                    });
                    this.setState({
                        absensiTerlambat: {
                            tanggal: tanggal,
                            terlambat: terlambat,
                            namaKaryawan: nama,
                        },
                        loadingTerlambat: false
                    })
                } else {
                    this.setState({ loadingTerlambat: false })
                }
            })
            .catch(() => this.setState({ loadingTerlambat: false }))
    }

    loadDataTepatWaktu() {
        this.setState({
            loadingTepatWaktu: true
        });
        let form = {
            tahun: this.state.selectedYear,
            bulan: this.state.selectedBulanTahun
        };
        this.props.request('presensi/pemantauan-tepat-waktu-v2', form, 'POST')
            .then(response => {
                if (response && response.success) {
                    var tanggal = [];
                    var tepatWaktu = [];
                    var nama = [];
                    response.data.map((item, index) => {
                        tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                        tepatWaktu.push((item.tepatWaktu !== null ? item.tepatWaktu : 0));
                        nama.push((item.nama !== null ? item.nama : 0));
                    });
                    this.setState({
                        absensiTepatWaktu: {
                            tanggal: tanggal,
                            tepatWaktu: tepatWaktu,
                            namaKaryawan: nama,
                        },
                        loadingTepatWaktu: false
                    })
                } else {
                    this.setState({ loadingTepatWaktu: false })
                }
            })
            .catch(() => this.setState({ loadingTepatWaktu: false }))
    }

    loadDataAbsensi() {
        this.setState({
            loadingAbsensi: true
        });
        let form = {
            year: this.state.selectedTahun,
            month: this.state.selectedBulan
        };
        this.props.request("list-absensiv3", form, 'POST')
            .then(response => {
                if (Array.isArray(response)) {
                    var tanggal = [];
                    var tepatWaktu = [];
                    var terlambat = [];
                    var izin = [];
                    response.map((item, index) => {
                        tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                        tepatWaktu.push((item.masuk !== null ? item.masuk : 0));
                        terlambat.push((item.terlambat !== null ? item.terlambat : 0));
                        izin.push((item.izin !== null ? item.izin : 0))
                    });
                    this.setState({
                        absensi: {
                            tanggal: tanggal,
                            tepatWaktu: tepatWaktu,
                            terlambat: terlambat,
                            izin: izin,
                        },
                        loadingAbsensi: false
                    })
                } else {
                    this.setState({ loadingAbsensi: false })
                }
            })
            .catch(() => this.setState({ loadingAbsensi: false }))
    }

    loadDataKaryawan() {
        this.setState({
            loading: true
        });
        let form = {};
        this.props.request("dashboard", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const isKaryawanNotNull = response.data.karyawan !== null;

                    this.setState({
                        data: response,
                        loading: false,
                        perusahaan: isKaryawanNotNull ? response.data : {
                            ...response.data,
                            karyawan: {
                                karyawan_laki_laki: 0,
                                karyawan_perempuan: 0,
                                total_karyawan: 0,
                                sisa_karyawan: 0,
                            }
                        }
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            }).catch(error => {
            console.error("Error loading data:", error);
            this.setState({
                loading: false
            });
        });
    }

    // loadCheck() {
    //     let form = {
    //         perusahaan_id: this.props.user.perusahaan_id
    //     }
    //     this.props.request("check-guide-data", form, "POST")
    //         .then((response) => {
    //             if (response.success) {
    //                 this.setState({
    //                     karyawan: response.karyawan
    //                 }, () => {
    //                     if (this.props.user.perusahaan.status === "new" && this.props.user.perusahaan.perusahaan_bidang !== null && this.props.user.perusahaan.perusahaan_alamat !== null && this.props.user.perusahaan.perusahaan_telp !== null) {
    //                         this.setState({
    //                             progresModal: true
    //                         })
    //                     }
    //                 })
    //             }
    //         })
    // }

    componentDidMount() {
        this.loadData()
        this.loadDataAbsensi()
        this.loadDataKaryawan()
        // this.loadCheck()

        setTimeout(() => {
            this.tourSteps = [];

            const totalKaryawan = this.state.perusahaan?.karyawan?.total_karyawan ?? 0;
            if (totalKaryawan === 0) {
                this.tourSteps.push({
                    selector: '.monitor-laporan-absen',
                    title: 'Belum Ada Data Kehadiran',
                    content: 'Belum ada data kehadiran karyawan. Pastikan karyawan sudah melakukan presensi atau periksa kembali filter periode yang dipilih.',
                });
            } else {
                this.tourSteps.push({
                    selector: '.monitor-laporan-absen',
                    title: 'Laporan Absen Semua Karyawan',
                    content: `Terdapat ${totalKaryawan} karyawan tercatat. Grafik ini menampilkan rekap kehadiran mencakup kategori Tepat Waktu, Terlambat, dan Izin.`,
                });
            }

            this.tourSteps.push(
                {
                    selector: '.monitor-laporan-terlambat',
                    title: 'Laporan 5 Karyawan Terlambat Teratas',
                    content: 'Grafik ini menampilkan karyawan dengan keterlambatan terbanyak pada periode yang dipilih.',
                },
                {
                    selector: '.monitor-laporan-tepat-waktu',
                    title: 'Laporan 5 Karyawan Tepat Waktu Teratas',
                    content: 'Grafik ini menampilkan karyawan paling disiplin yang paling sering hadir tepat waktu.',
                },
                {
                    selector: '.monitor-limit-karyawan',
                    title: 'Laporan Limit Karyawan',
                    content: `Menampilkan jumlah karyawan aktif dibandingkan batas maksimum paket Anda. Pastikan jumlah karyawan tidak melebihi limit yang tersedia.`,
                },
                {
                    selector: '.monitor-jenis-kelamin',
                    title: 'Perbandingan Jenis Kelamin',
                    content: 'Grafik ini menampilkan persentase komposisi karyawan berdasarkan jenis kelamin di perusahaan Anda.',
                },
            );

            const {setSteps, setCurrent, setActive} = this.context;
            setSteps(this.tourSteps);
            setCurrent(0);
            setActive(true);
        }, 500)
    }

    renderLoading() {
        return (
            <div className="pemantauan-loading">
                <div className="spinner-border" role="status" aria-hidden="true"/>
                <span>Sedang memuat data...</span>
            </div>
        );
    }

    renderEmpty() {
        return (
            <div className="pemantauan-empty">
                <i className="fa fa-inbox empty-icon" aria-hidden="true"/>
                <span>Belum ada data pada periode ini</span>
            </div>
        );
    }

    render() {
        const { absensi, absensiTerlambat, absensiTepatWaktu, perusahaan } = this.state;

        const sum = (arr) => Array.isArray(arr) ? arr.reduce((acc, v) => acc + (Number(v) || 0), 0) : 0;

        const totalTepatWaktu = sum(absensi.tepatWaktu);
        const totalTerlambat = sum(absensi.terlambat);
        const totalIzin = sum(absensi.izin);

        const totalKaryawan = perusahaan && perusahaan.karyawan ? Number(perusahaan.karyawan.total_karyawan) || 0 : 0;
        const sisaKaryawan = perusahaan && perusahaan.karyawan ? Number(perusahaan.karyawan.sisa_karyawan) || 0 : 0;
        const limitTotal = totalKaryawan + sisaKaryawan;
        const usagePercent = limitTotal > 0 ? Math.round((totalKaryawan / limitTotal) * 100) : 0;

        const jumlahLaki = totalKaryawan > 0 && perusahaan.karyawan ? Number(perusahaan.karyawan.karyawan_laki_laki) || 0 : 0;
        const jumlahPerempuan = totalKaryawan > 0 && perusahaan.karyawan ? Number(perusahaan.karyawan.karyawan_perempuan) || 0 : 0;
        const perbandinganlaki = totalKaryawan > 0 ? (jumlahLaki / totalKaryawan) * 100 : 0;
        const perbandinganperempuan = totalKaryawan > 0 ? (jumlahPerempuan / totalKaryawan) * 100 : 0;

        const hasAbsensi = Array.isArray(absensi.tanggal) && absensi.tanggal.length > 0;
        const hasTerlambat = Array.isArray(absensiTerlambat.namaKaryawan) && absensiTerlambat.namaKaryawan.length > 0;
        const hasTepatWaktu = Array.isArray(absensiTepatWaktu.namaKaryawan) && absensiTepatWaktu.namaKaryawan.length > 0;

        const yearOptions = [2026, 2025, 2024, 2023, 2022].map((y) => (
            <option key={y} value={y}>{y}</option>
        ));

        const barOptions = {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: true,
                position: 'top',
                align: 'end',
                labels: {
                    usePointStyle: true,
                    boxWidth: 8,
                    fontSize: 12,
                    fontColor: '#64748b',
                    padding: 16,
                },
            },
            tooltips: {
                backgroundColor: '#1e293b',
                titleFontSize: 12,
                bodyFontSize: 12,
                cornerRadius: 6,
                xPadding: 12,
                yPadding: 12,
                displayColors: true,
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    barPercentage: 0.6,
                    categoryPercentage: 0.55,
                    gridLines: { display: false },
                    ticks: {
                        fontSize: 11,
                        fontColor: '#94a3b8',
                        autoSkip: false,
                        maxRotation: 45,
                        padding: 8,
                    },
                }],
                yAxes: [{
                    stacked: true,
                    min: 0,
                    ticks: {
                        beginAtZero: true,
                        stepSize: 1,
                        fontSize: 11,
                        fontColor: '#94a3b8',
                    },
                    gridLines: {
                        color: 'rgba(148, 163, 184, 0.15)',
                        drawBorder: false,
                    },
                }],
            },
        };

        const dataAbsenTerlambat = {
            labels: this.state.absensiTerlambat.namaKaryawan,
            datasets: [
                {
                    label: 'Terlambat',
                    data: this.state.absensiTerlambat.terlambat,
                    backgroundColor: 'rgba(239, 68, 68, 0.85)',
                    borderColor: '#dc2626',
                    borderWidth: 1,
                    borderRadius: 6,
                    borderSkipped: false,
                    maxBarThickness: 40
                }
            ]
        };
        const dataAbsenTepatWaktu = {
            labels: this.state.absensiTepatWaktu.namaKaryawan,
            datasets: [
                {
                    label: 'Tepat Waktu',
                    data: this.state.absensiTepatWaktu.tepatWaktu,
                    backgroundColor: 'rgba(34, 197, 94, 0.85)',
                    borderColor: '#16a34a',
                    borderWidth: 1,
                    borderRadius: 6,
                    borderSkipped: false,
                    maxBarThickness: 40
                }
            ]
        };
        const dataAbsen = {
            labels: this.state.absensi.tanggal,
            datasets: [
                {
                    label: 'Tepat Waktu',
                    data: this.state.absensi.tepatWaktu,
                    backgroundColor: 'rgba(34, 197, 94, 0.85)',
                    borderColor: '#16a34a',
                    borderWidth: 1,
                    borderRadius: 4,
                    borderSkipped: false,
                },
                {
                    label: 'Terlambat',
                    data: this.state.absensi.terlambat,
                    backgroundColor: 'rgba(239, 68, 68, 0.85)',
                    borderColor: '#dc2626',
                    borderWidth: 1,
                    borderRadius: 4,
                    borderSkipped: false,
                },
                {
                    label: 'Izin',
                    data: this.state.absensi.izin,
                    backgroundColor: 'rgba(245, 158, 11, 0.85)',
                    borderColor: '#d97706',
                    borderWidth: 1,
                    borderRadius: 4,
                    borderSkipped: false,
                },
            ]
        };
        const limitOption = {
            title: "",
            pieHole: 0.62,
            slices: [{
                color: "#E2E8F0"
            },
                {
                    color: "#057CE4"
                },
            ],
            pieSliceText: "none",
            tooltip: {
                showColorCode: true
            },
            chartArea: {
                width: '100%',
                height: '100%'
            },
            legend: "none",
            backgroundColor: "transparent"
        };
        const genderOption = {
            title: "",
            pieHole: 0.62,
            slices: [{
                color: "#057CE4"
            },
                {
                    color: "#FF9C00"
                },
            ],
            pieSliceText: "none",
            tooltip: {
                showColorCode: true
            },
            chartArea: {
                width: '100%',
                height: '100%'
            },
            legend: "none",
            backgroundColor: "transparent"
        };
        return(
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Monitor Perusahaan - Presensi</title>
                    <meta name="description" content="Daftar Monitor"/>
                </Helmet>
                <div className="container-fluid pt-4">
                    <div className="pemantauan-breadcrumb">Presensi Admin Panel</div>
                    <div className='row mb-4'>
                        <div className='col-md-12'>
                            <div className="pemantauan-title">
                                Monitor Perusahaan
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className="col-xl-9 col-md-9">
                            <div className="card pemantauan-card">
                                <div className="card-body monitor-laporan-absen">
                                    <div className="pemantauan-card-header">
                                        <div className="pemantauan-card-title">
                                            <span className="card-icon icon-blue">
                                                <i className="fa fa-bar-chart" aria-hidden="true"/>
                                            </span>
                                            Laporan Absen Semua Karyawan
                                        </div>
                                        <div className="pemantauan-filter-group">
                                            <div className="pemantauan-filter">
                                                <label>Filter Tahun</label>
                                                <select name="year" className="form-control"
                                                        value={this.state.selectedTahun}
                                                        onChange={this.handleYearChange}>
                                                    {yearOptions}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Filter Bulan</label>
                                                <select name="month" className="form-control"
                                                        value={this.state.selectedBulan}
                                                        onChange={this.handleBulanTahunChange}>
                                                    {this.generateOptions()}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Reset</label>
                                                <button className="pemantauan-refresh-btn"
                                                        onClick={this.resetFilter}
                                                        title="Reset Filter">
                                                    <img alt='' src={RefreshIcon}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pemantauan-stats">
                                        <div className="pemantauan-stat stat-blue">
                                            <div className="stat-label">Total Karyawan</div>
                                            <div className="stat-value">{totalKaryawan}</div>
                                        </div>
                                        <div className="pemantauan-stat stat-green">
                                            <div className="stat-label">Tepat Waktu</div>
                                            <div className="stat-value">{totalTepatWaktu}</div>
                                        </div>
                                        <div className="pemantauan-stat stat-red">
                                            <div className="stat-label">Terlambat</div>
                                            <div className="stat-value">{totalTerlambat}</div>
                                        </div>
                                        <div className="pemantauan-stat stat-amber">
                                            <div className="stat-label">Izin</div>
                                            <div className="stat-value">{totalIzin}</div>
                                        </div>
                                    </div>
                                    <div className="pemantauan-chart">
                                        {this.state.loadingAbsensi ? this.renderLoading() : (
                                            hasAbsensi ? (
                                                <div className="market-chart">
                                                    <Bar data={dataAbsen}
                                                         options={barOptions}
                                                         width={"100%"}
                                                         height={360}
                                                    />
                                                </div>
                                            ) : this.renderEmpty()
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="card pemantauan-card">
                                <div className="card-body monitor-laporan-terlambat">
                                    <div className="pemantauan-card-header">
                                        <div className="pemantauan-card-title">
                                            <span className="card-icon icon-red">
                                                <i className="fa fa-hourglass-half" aria-hidden="true"/>
                                            </span>
                                            Laporan 5 Karyawan Terlambat Teratas
                                        </div>
                                        <div className="pemantauan-filter-group">
                                            <div className="pemantauan-filter">
                                                <label>Filter Tahun</label>
                                                <select name="year" className="form-control"
                                                        value={this.state.selectedYear}
                                                        onChange={this.handleTahun}>
                                                    {yearOptions}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Filter Bulan</label>
                                                <select name="month" className="form-control"
                                                        value={this.state.selectedBulanTahun}
                                                        onChange={this.handleBulan}>
                                                    {this.generateOptions()}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Reset</label>
                                                <button className="pemantauan-refresh-btn"
                                                        onClick={this.resetFilterTerlambat}
                                                        title="Reset Filter">
                                                    <img alt='' src={RefreshIcon}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pemantauan-chart-sm">
                                        {this.state.loadingTerlambat ? this.renderLoading() : (
                                            hasTerlambat ? (
                                                <div className="market-chart">
                                                    <Bar data={dataAbsenTerlambat}
                                                         options={barOptions}
                                                         width={"100%"}
                                                         height={300}
                                                    />
                                                </div>
                                            ) : this.renderEmpty()
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="card pemantauan-card">
                                <div className="card-body monitor-laporan-tepat-waktu">
                                    <div className="pemantauan-card-header">
                                        <div className="pemantauan-card-title">
                                            <span className="card-icon icon-green">
                                                <i className="fa fa-check-circle" aria-hidden="true"/>
                                            </span>
                                            Laporan 5 Karyawan Tepat Waktu Teratas
                                        </div>
                                        <div className="pemantauan-filter-group">
                                            <div className="pemantauan-filter">
                                                <label>Filter Tahun</label>
                                                <select name="year" className="form-control"
                                                        value={this.state.selectedYear}
                                                        onChange={this.handleTahunTepatWaktu}>
                                                    {yearOptions}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Filter Bulan</label>
                                                <select name="month" className="form-control"
                                                        value={this.state.selectedBulanTahun}
                                                        onChange={this.handleBulanTepatWaktu}>
                                                    {this.generateOptions()}
                                                </select>
                                            </div>
                                            <div className="pemantauan-filter">
                                                <label>Reset</label>
                                                <button className="pemantauan-refresh-btn"
                                                        onClick={this.resetFilterTepatWaktu}
                                                        title="Reset Filter">
                                                    <img alt='' src={RefreshIcon}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pemantauan-chart-sm">
                                        {this.state.loadingTepatWaktu ? this.renderLoading() : (
                                            hasTepatWaktu ? (
                                                <div className="market-chart">
                                                    <Bar data={dataAbsenTepatWaktu}
                                                         options={barOptions}
                                                         width={"100%"}
                                                         height={300}
                                                    />
                                                </div>
                                            ) : this.renderEmpty()
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-3">
                            <div className="card pemantauan-card">
                                <div className="card-body monitor-limit-karyawan">
                                    <div className="pemantauan-side-title">
                                        <span className="dot" style={{background: '#057CE4'}}/>
                                        Laporan Limit Karyawan
                                    </div>
                                    <div className="pemantauan-donut-wrap">
                                        {this.state.loading ? (
                                            <div className="pemantauan-loading">
                                                <div className="spinner-border" role="status" aria-hidden="true"/>
                                            </div>
                                        ) : (
                                            <Chart
                                                chartType="PieChart"
                                                data={[
                                                    ['Laporan', 'Limit Karyawan'],
                                                    ['Sisa Slot Karyawan', sisaKaryawan],
                                                    ['Karyawan', totalKaryawan],
                                                ]}
                                                options={limitOption}
                                                graph_id="LimitChart"
                                                width="100%"
                                                height="150px"
                                                legend_toggle/>
                                        )}
                                    </div>
                                    <div className="pemantauan-usage">
                                        <div className="usage-label">
                                            <span>Karyawan Terpakai</span>
                                            <span>{totalKaryawan} / {limitTotal}</span>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" style={{width: usagePercent + '%'}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card pemantauan-card">
                                <div className="card-body monitor-jenis-kelamin">
                                    <div className="pemantauan-side-title">
                                        <span className="dot" style={{background: '#FF9C00'}}/>
                                        Perbandingan Jenis Kelamin
                                    </div>
                                    <div className="pemantauan-donut-wrap">
                                        {this.state.loading ? (
                                            <div className="pemantauan-loading">
                                                <div className="spinner-border" role="status" aria-hidden="true"/>
                                            </div>
                                        ) : (
                                            <Chart
                                                chartType="PieChart"
                                                data={[
                                                    ['Perbandingan', 'Gender'],
                                                    ['Laki-laki', jumlahLaki],
                                                    ['Perempuan', jumlahPerempuan],
                                                ]}
                                                options={genderOption}
                                                graph_id="GenderChart"
                                                width="100%"
                                                height="150px"
                                                legend_toggle/>
                                        )}
                                    </div>
                                    <div className="pemantauan-gender-row">
                                        <div className="gender-item">
                                            <div className="gender-label">
                                                <span>Laki-laki</span>
                                                <span>{perbandinganlaki.toFixed(1)}%</span>
                                            </div>
                                            <div className="gender-bar">
                                                <span className="gender-male" style={{width: perbandinganlaki.toFixed(1) + '%'}}/>
                                            </div>
                                        </div>
                                        <div className="gender-item">
                                            <div className="gender-label">
                                                <span>Perempuan</span>
                                                <span>{perbandinganperempuan.toFixed(1)}%</span>
                                            </div>
                                            <div className="gender-bar">
                                                <span className="gender-female" style={{width: perbandinganperempuan.toFixed(1) + '%'}}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(Pemantauan, PERMISSIONS.PEMANTAUAN));
